import { MenuItem } from "react-bootstrap";
import Peer from "./Peer";

export default class Producer {

    constructor() {
        this.peer = new Peer();
        this.producers = {};
        this.endedCallbacks = {};
        this.activeEncodings = [0, 1, 2];
        this.currentsBitrate = {};
    }

    async init() {
        await this.peer.start('send');
    }

    getPeer() {
        return this.peer;
    }

    async produceAudio(track, mediaTag = 'cam-audio', appData = {}) {    
        this.producers[mediaTag] = await this.peer.startProduce(track, mediaTag, {
            appData
        });        
    }

    getSimulcastEncodings(megaBitrate) {
        let bitrate = megaBitrate * 1000000;
        return [
            { maxBitrate: bitrate / 4, scaleResolutionDownBy: 4, active: this.activeEncodings.indexOf(0) !== -1 },
            { maxBitrate: bitrate / 2, scaleResolutionDownBy: 2, active: this.activeEncodings.indexOf(1) !== -1 },
            { maxBitrate: bitrate, scaleResolutionDownBy: 1, active: this.activeEncodings.indexOf(2) !== -1 }
        ]
    }

    setActiveEncodings(value) {
        switch(value) {
            case '180p':
                this.activeEncodings = [0];
                break;
            case '360p':
                this.activeEncodings = [0, 1];
                break;
            default: 
                this.activeEncodings = [0, 1, 2];
                break;
        }
    }

    updateBitrate(mediaTag, megaBitrate = false) {        
        if(!this.currentsBitrate[mediaTag])
            return;
        if(megaBitrate === false)
            megaBitrate = this.currentsBitrate[mediaTag];
        this.currentsBitrate[mediaTag] = megaBitrate;
        const params = this.producers[mediaTag].rtpSender.getParameters();
        let newEncodings = this.getSimulcastEncodings(megaBitrate);
        for(var i in params.encodings) {            
            params.encodings[i] = Object.assign(params.encodings[i], newEncodings[i]);            
        }        
        this.producers[mediaTag].rtpSender.setParameters(params);
    }

    async produceVideo(track, mediaTag = 'cam-video', appData = {}) {
        if(!this.currentsBitrate[mediaTag])
            this.currentsBitrate[mediaTag] = 2;
        
        let producerOpt = {};

        let encodings = this.getSimulcastEncodings(this.currentsBitrate[mediaTag]); //broadcast to 2 Mb/s

        if(!mediaTag.startsWith('screen') && !window.sdk.session().isExtern() && mediaTag == 'cam-video') { //we force simulcast only for cam-video            
            producerOpt.encodings = encodings;
        }        

        producerOpt.appData = appData;

        this.producers[mediaTag] = await this.peer.startProduce(track, mediaTag, producerOpt);        
    }

    async pause(mediaTag) {
        return await this.producers[mediaTag].pause2();
    }

    async resume(mediaTag) {
        if(!this.producers[mediaTag])
            console.log('need to produce first');
        else
            return await this.producers[mediaTag].resume2();
    }

    async close(mediaTag) {
        let res;
        try {
            res = await this.producers[mediaTag].close2();
        }
        catch(err) {
            
        }
        return res;
    }

    async closeAll() {
        for(var i in this.producers) {
            await this.producers[i].close2();
        }
    }

    async removePeer() {
        await this.peer.sig('/remove-peer');
        await this.closeAll();        
        await this.peer.close();           
    }

    async replaceTrack(track, mediaTag) {
        if(!this.producers[mediaTag])
            mediaTag == 'cam-video' ? await this.produceVideo(track) : await this.produceAudio(track)
        else
            return await this.producers[mediaTag].replaceTrack({ track: track });
    }


}